export default {
  // Index
  scheduleAMeeting: {
    english: "Schedule an Appointment",
    spanish: "Programar una reunión",
  },
  // Available-Time-Slots
  chooseATopic: {
    english: "Please choose a Topic",
    spanish: "Escoge un tema",
  },
  date: {
    english: "Date",
    spanish: "Fecha",
  },
  chooseWith: {
    english: "Choose with",
    spanish: "Elige con quien",
  },
  chooseATimeSlot: {
    english: "Please select with",
    spanish: "Elige con quien",
  },
  noFoundTimeSlots: {
    english: "Sorry, we could not find any Time Slots.",
    spanish: "Lo sentimos, no pudimos encontrar ninguna franja horaria.",
  },
  // submit is from profile

  // Time-Slot-Search-Form
  selectADate: {
    english: "Select A Date",
    spanish: "Seleccione una fecha",
  },
  enterDescription: {
    english: "Enter description",
    spanish: "Ingrese una descripción"
  },
  chooseAChatType: {
    english: "Enter the Chat type",
    spanish: "Ingrese el tipo de chat"
  },
  scheduleNew:{
    english:'Schedule New',
    spanish: "Programar una reunión",
  },

  today: {
    english: "Today",
    spanish: "Hoy"
  },
  loadingPleaseWait: {
    english: "Loading, please wait.",
    spanish: "Cargando, por favor espere."
  },
  stepAnnouncement0Prefix: {
    english: "Step 1 of 3: ",
    spanish: "Paso 1 de 3: "
  },
  stepAnnouncement1Prefix: {
    english: "Step 1 of 3 completed. Step 2 of 3: ",
    spanish: "Paso 1 de 3 completado. Paso 2 de 3: "
  },
  stepAnnouncement2Prefix: {
    english: "Steps 1 and 2 completed. Step 3 of 3: ",
    spanish: "Pasos 1 y 2 completados. Paso 3 de 3: "
  }
};
